import * as React from 'react'

import { Box } from '@factorialco/deprecated-design-system'
import { ResponsiveRadar } from '@nivo/radar'

import { observer } from 'mobx-react'

import type { Assessment } from 'modules/competencies/store/models/Assessment'

import { normalizeData } from './normalizeData'

interface Props {
  assessments: Assessment[]
}

const SpiderWeb: React.FC<Props> = ({ assessments }) => {
  const assessmentData = assessments.map((assessment) => ({
    competencyName: assessment.competency.name,
    competencyRange: assessment.competency.range,
    optionValue: assessment.option?.value,
  }))

  const { max, data } = normalizeData(assessmentData)

  return (
    <Box padding="s12" style={{ height: '600px' }}>
      <ResponsiveRadar
        data={data}
        colors={['#FFFFFF00', '#68CC45']}
        margin={{ top: 40, right: 100, bottom: 40, left: 100 }}
        indexBy="name"
        keys={['max', 'rating']}
        maxValue={max}
        gridLevels={5}
        dotBorderWidth={2}
        gridLabelOffset={34}
        borderColor={{ from: 'color' }}
        isInteractive={false}
      />
    </Box>
  )
}

export default observer(SpiderWeb)
